import { render } from "./About.vue?vue&type=template&id=e53726c8"
const script = {}
script.render = render

export default script